import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";

export default class MarketplaceFeeScheduleCategoryAPIRequest {
  public name: string;
  public description?: string;
  public billingCode?: string;
  public feeRate?: number;
  public feeCurrency?: string;
  public feeUnit?: string;

  public constructor(feeCategory: FeeScheduleCategory) {
    const name = feeCategory.name.value;
    if (!name) {
      throw new Error("Fee schedule category name is required");
    }

    this.name = name;
    this.description = feeCategory.description?.value ?? "";
    this.billingCode = feeCategory.billingCode?.value ?? "";
    this.feeRate = feeCategory.fee?.rate.amount;
    this.feeCurrency = feeCategory.fee?.rate.currency;
    this.feeUnit = feeCategory.fee?.unit ?? undefined;
  }
}
